module.exports = __webpack_public_path__ + "img/smn.c3ca8095.jpg";